import PointManager from "../PointManager";
import { getRandomUniqueNumbers } from "../../../../../../../src/utils/generator/getRandomUniqueNumbers";
import { moveAllPointAnim } from "../../../../../../../src/animation/Circle/helpers/drawHelpers";


export async function generateRandomlyRadians(PointManager: PointManager) {
  const radians = PointManager.getRadians();
  const RedPoints = PointManager.getRedPoints();
  const newRadians = getRandomUniqueNumbers(3, 0, 5).sort((a, b) => a - b);
  newRadians.map((v: number) => (v * (Math.PI / 3))).sort().reverse();
  await moveAllPointAnim(radians, newRadians, (radian, index) => PointManager.setRadian([{ pTag: RedPoints[index].tag, radian }]))
}